// extracted by mini-css-extract-plugin
module.exports = {"content":"InternationalStudents_content__jtN2P","text":"InternationalStudents_text__q0tua"};